export const QUEST_TREASURE_SELECTION_STORAGE_KEY =
  "vocabularium_quest_treasure_selection";

function readSelectionMap() {
  try {
    const raw = localStorage.getItem(QUEST_TREASURE_SELECTION_STORAGE_KEY);
    if (!raw) return {};

    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      return parsed;
    }

    if (typeof parsed === "string") {
      return { aztec: parsed };
    }
  } catch {
    // ignore
  }

  return {};
}

export function readQuestTreasureSelection(collectionId, relicIds, fallbackId) {
  if (!collectionId || !Array.isArray(relicIds) || relicIds.length === 0) {
    return fallbackId || null;
  }

  const selections = readSelectionMap();
  const savedId = selections[collectionId];
  if (savedId && relicIds.includes(savedId)) return savedId;

  return fallbackId || relicIds[0];
}

export function writeQuestTreasureSelection(collectionId, relicId) {
  if (!collectionId || !relicId) return;

  try {
    const selections = readSelectionMap();
    selections[collectionId] = relicId;
    localStorage.setItem(
      QUEST_TREASURE_SELECTION_STORAGE_KEY,
      JSON.stringify(selections)
    );
  } catch {
    // ignore quota / privacy mode errors
  }
}
